export const table_titles = [
	{ name: "#", size: 5, order: "" },
	{ name: "Nombre", size: 20, order: "name" },
	{ name: "Campo", size: 20, order: "" },
	{ name: "Bodega", size: 20, order: "" },
	{ name: "Categoría", size: 20, order: "" },
	{ name: "Acción", size: 10, order: "" },
];

export const customStyles = {
	menuPortal: (base) => ({
		...base,
		zIndex: 9999999,
	}),
	menu: (provided) => ({ ...provided, zIndex: 9999999 }),
};
